import { render, staticRenderFns } from "./Procedimientos.vue?vue&type=template&id=d225f5ce&scoped=true&"
import script from "./Procedimientos.vue?vue&type=script&lang=js&"
export * from "./Procedimientos.vue?vue&type=script&lang=js&"
import style0 from "./Procedimientos.vue?vue&type=style&index=0&id=d225f5ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d225f5ce",
  null
  
)

export default component.exports